import { getStage } from "./context";

export const showCommsPreferences = getStage() !== "prod";

export const showBoylInvoiceTerms = getStage() !== "prod";

export const showContractAddendum = getStage() !== "prod";
